module.exports = __webpack_public_path__ + "static/media/gym.3b602365.png";